import React from "react";
import './style.css';

const Loader_8 = () => {
  return (
    <div className="loader-8">
      <div className="loader"></div>
    </div>
  );
};

export default Loader_8;